angular.module('gym.mobile_app').directive('mobileAppSettingsProximityCheckinAddresses', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/mobile_app/proximity_checkin_addresses.html.slim'),
    controller: ["$scope", "$window", "$modal", "MobileApp", "ProximityCheckinLocations", function($scope, $window, $modal, MobileApp, ProximityCheckinLocations) {
      var loadLocations;
      MobileApp.all('settings').doGET('meta').then(function(data) {
        return $scope.meta = data.plain();
      });
      loadLocations = function() {
        return ProximityCheckinLocations.getList({
          count: 1000
        }).then(function(addresses) {
          return $scope.addresses = addresses;
        });
      };
      loadLocations();
      $scope.deleteAddress = function(address) {
        if ($window.confirm("Are you sure?")) {
          return address.remove().then(function() {
            return loadLocations();
          });
        }
      };
      return $scope.edit = function(address) {
        var modalInstance;
        if (!$scope.meta) {
          return;
        }
        modalInstance = $modal.open({
          template: require('templates/gyms/mobile_app/edit_proximity_checkin_address.html.slim'),
          size: 'lg',
          resolve: {
            address: function() {
              return address;
            },
            meta: function() {
              return $scope.meta;
            }
          },
          controller: 'EditProximityCheckinAddressCtrl'
        });
        return modalInstance.result.then(function() {
          return loadLocations();
        });
      };
    }]
  };
});
